import styles from '../HardwarePayment/HardwarePayment.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from 'src/components/Cart/UseCart';
import { TextV2 } from 'src/components/TextV2/TextV2';

export const ProductList: React.FC = () => {
  const { t } = useTranslation();
  const { cart } = useCart();
  const hardwareItems = [...cart?.bundle?.hardware || [], ...cart?.products];

  return (
    <>
      {hardwareItems?.map(item => {
        return (
          <div className={styles.container} key={item.id} data-test="checkout-item">
            <TextV2
              variant="body"
              tagName="span"
              value={item.name}
              className={styles.containerLabel}
              data-test="product-name"
            />
            <TextV2
              variant="body"
              tagName="span"
              value={t('order-summary.price', { price: item.totalCost * item.quantity })}
              data-test="product-total-cost"
            />
          </div>
        );
      })}
    </>
  );
};

ProductList.displayName = 'ProductList';
